import React from 'react';
import GlobeIcon from '../GlobeIcon';

/*
 * The web chat channel.
 *
 * A globe, and deliberately the app's own globe rather than a second drawing of
 * one: GlobeIcon already stands for "a website" where the AI is pointed at one
 * to read, and a visitor who arrived through the widget arrived from the web.
 * One mark, one meaning.
 *
 * It used to be a monitor with chat lines in it, which said "desktop" rather
 * than "the web" - and the mobile counterpart was a different drawing again, so
 * the two never read as one channel seen from two devices. WebchatMobileIcon is
 * this mark with a phone beside it.
 */
const WebchatIcon = (props) => <GlobeIcon {...props}/>;

export default WebchatIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/platforms/WebchatIcon.jsx